import React, { useState } from "react";
import "./Index.css";
import SidebarMenus from "./SidebarMenus";
import { Outlet } from "react-router-dom";
import Topbar from "./Topbar";

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="wrapper">
      <div className="content-wrapper">
        <Topbar collapsed={collapsed} setCollapsed={setCollapsed} />
        <div className="content-body-wrapper bg-white">
          <div className="sidebar-menu border-gray-200">
            <SidebarMenus collapsed={collapsed} setCollapsed={setCollapsed} />
          </div>
          <div className=" content-body overflow-x-hidden overflow-y-scroll p-2">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
